import { initializeChakraComponent } from 'Shared/chakra-initialize';
import { useEffect, useRef, useState } from 'react';
import YouTube from 'react-youtube';

type YouTubePlayerProps = {
   videoId: string;
   startTimestamp: number;
   endTimestamp: number;
};

export default function YouTubeVideoPreview({
   videoId,
   startTimestamp,
   endTimestamp,
}: YouTubePlayerProps) {
   const playerRef = useRef<YouTube | null>(null);
   const [startTimestampInput, setStartTimestampInput] = useState(startTimestamp);
   const [endTimestampInput, setEndTimestampInput] = useState(endTimestamp);

   const startTimestampInputElement = document.querySelector('#editStartTimestampInput');
   const handleStartTimestampChange = () => {
      const inputElement = document.querySelector('#editStartTimestampInput');
      const inputElementValue = (inputElement as HTMLInputElement)?.value;
      if (inputElement && !Number.isNaN(inputElementValue)) {
         setStartTimestampInput(Number(inputElementValue));
      } else if (inputElementValue === '') {
         setStartTimestampInput(0);
      }
   };
   startTimestampInputElement?.addEventListener('change', handleStartTimestampChange);

   const endTimestampInputElement = document.querySelector(
      '#editEndTimestampInput'
   ) as HTMLInputElement;
   const handleEndTimestampChange = () => {
      const inputElement = document.querySelector('#editEndTimestampInput');
      const inputElementValue = (inputElement as HTMLInputElement)?.value;
      if (inputElement && !Number.isNaN(inputElementValue)) {
         setEndTimestampInput(Number(inputElementValue));
      } else if (inputElementValue === '') {
         setEndTimestampInput(Number.MAX_VALUE);
      }
   };
   endTimestampInputElement?.addEventListener('change', handleEndTimestampChange);

   useEffect(() => {
      const player = playerRef.current?.internalPlayer;
      let intervalId: ReturnType<typeof setInterval> | null = null;
      if (
         startTimestampInput !== null &&
         endTimestampInput !== null &&
         startTimestampInput < endTimestampInput
      ) {
         player.seekTo(startTimestampInput);
         intervalId = setInterval(() => {
            player.getCurrentTime().then((time: number) => {
               if (time >= endTimestampInput) {
                  player.seekTo(startTimestampInput);
               }
            });
         }, 500);
      }
      // Cleanup when the component unmounts
      return () => {
         if (intervalId) clearInterval(intervalId);
      };
   }, [startTimestampInput, endTimestampInput]);

   return (
      <div className="stepYouTubeVideo">
         <YouTube
            videoId={videoId}
            opts={{
               width: '100%',
               height: '100%',
            }}
            className={'youtube-preview-player-iframe'}
            ref={playerRef}
         />
      </div>
   );
}

initializeChakraComponent('YouTubeVideoPreviewComponent', YouTubeVideoPreview);
